import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import * as QuillNamespace from "quill";
import ImageResize from "quill-image-resize-module";
import { MessagingStructure } from "src/app/services/features-by-plan/interface/messaging";
import { MessagingService } from "src/app/services/messaging.service";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { CommonService } from "../../services/common.service";
let Quill: any = QuillNamespace;
Quill.register("modules/imageResize", ImageResize);

@Component({
  selector: "app-campaign",
  templateUrl: "./campaign.component.html",
  styleUrls: ["./campaign.component.scss"],
})
export class CampaignComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  logo_url: String;
  reviewTemplateForm: FormGroup;
  all_templates: any = [];
  dataService: any;
  isValidFormSubmitted: boolean = true;
  value: string;
  outlet_id: string;
  smsType: boolean = false;
  emailType: boolean = false;
  sendMsg2: boolean = false;
  button_name: String;
  button_image: any;
  closeResult: string;
  template_id: string;
  selected_template_id: String;
  qrcode_link: any;
  business_name: any;
  brandLogo: boolean = false;
  brandName: boolean = false;
  powerBy: boolean = false;
  qrCodeSettingForm: FormGroup;
  reviewEmailTemplateForm: FormGroup;
  email_template_html_data: any;
  role: string = this.storage.get("role");
  show_button: boolean = false;
  show_button1: boolean = false;
  smsMaxLength: number;
  smsMaxLength1: number;
  smsMaxLengthEdit: number;
  smscount: any = [];
  smsMaxLengthToastr: any;
  showNoDefaultTemplate: boolean = false;
  showNoCustomTemplate: boolean = false;
  permissions: any;
  total_credits: number = 10;
  regional_total_credits: number = 15;
  used_credits: number = 1;
  regional_used_credits: number;

  @ViewChild("content") content;
  @ViewChild("input1", { read: ElementRef }) private _inputElement: ElementRef;
  @ViewChild("saveAsNewTemplateModel", { read: ElementRef })
  saveAsNewTemplateModel: ElementRef;
  saveAsNewTemplateButton: boolean = false;
  templateChannel: any;
  smsTemplates: any = [];
  emailTemplates: any = [];
  showNoDefaultTemplateEmail: boolean;
  showNoCustomTemplateEmail: boolean;
  saveAsNewTemplateButtonEmail: boolean;
  editorStyles: {};
  modules: {};
  regionalMaxLength: any;
  regionalLanguage: boolean;
  regionalSmsMaxLength: any;
  is_campaign_blocked: any;
  campaign_warning_text: any = "";
  isApproved: any;
  updatedTemplate: any;
  isDefaultTemplate: any;
  newDltTemplateForm: FormGroup;
  hideSaveButton: boolean;
  showDltWarning: any;
  checkInternationalCountry: boolean;
  allowedChannels: any = [];
  default_sms_template: any;
  default_email_template: any;
  predefinedVariables: any[] = [];
  dynamicVariables: any = {};
  objectKeys = Object.keys;
  selectedTemplate: any;
  chooseChannel;
  available_channels = [];

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    public formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private messagingService: MessagingService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outlet_id = this.storage.get("outlet_id");
    this.checkInternationalCountry =
      this.storage.get("business_country_name") !== "India";
    let res: Response;
    const setup_value = this.HttpService.get(
      this.BASE_URL.REVIEW_SETUP_VALUE_URL_V2(this.outlet_id)
    );
    setup_value.subscribe((data: Response) => {
      res = data;
      this.setSmsMaxLength();
    });
    this.getPromotionalTemplates();

    this.button_name = "Add";
    this.button_image = "assets/images/add-fff.svg";
    this.value = "https://api.zceppa.com/qrcode/" + this.outlet_id;
    this.reviewTemplateForm = this.formBuilder.group({
      review_title: [""],
      review_content: ["", Validators.compose([Validators.required])],
      template_id: [""],
      set_default: [""],
      dlt_template_id: ["", Validators.compose([Validators.required])],
    });
    this.newDltTemplateForm = this.formBuilder.group({
      new_dlt_template_id: ["", Validators.compose([Validators.required])],
    });
    this.qrCodeSettingForm = this.formBuilder.group({
      brand_logo: ["", Validators.compose([Validators.required])],
      brand_name: ["", Validators.compose([Validators.required])],
      description: [""],
      subtitle: [""],
      title: ["", Validators.compose([Validators.required])],
      zceppa_powered: ["", Validators.compose([Validators.required])],
    });
    this.reviewEmailTemplateForm = this.formBuilder.group({
      review_title: [""],
      review_content: ["", Validators.compose([Validators.required])],
      template_id: [""],
      set_default: [""],
    });
    this.getPredefinedVariables();
    const userInfo = this.HttpService.get(
      this.BASE_URL.DASHBOARD_PROFILE_URL(this.outlet_id)
    );
    userInfo.subscribe((data: Response) => {
      res = data;
      this.business_name = res.data["business_name"];
    });

    const data_service = this.HttpService.get(
      this.BASE_URL.GET_LOGO_URL(this.outlet_id)
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        if (error.status === 404) {
          this.logo_url = "NO_IMAGE";
        }
      },
      () => {
        this.logo_url = res.data["url"];
      }
    );

    this.commonservice.logo_image.subscribe((result) => {
      if (result !== null) {
        this.logo_url = result;
      }
    });

    this.editorStyles = {
      "min-height": "150px",
      height: "300px",
      // ...(this.isValidFormSubmitted == false && (this.reviewFormData.content.value == '' || this.reviewFormData.content.value == null) && { 'border': '1px solid #ff0000' })
    };

    // quill editor
    this.modules = {
      toolbar: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote", "code-block"],
        [{ header: 1 }], // custom button values
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ direction: "rtl" }], // text direction
        [{ size: ["small", false, "large", "huge"] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }],
        ["clean"], // remove formatting button
        ["link"], // link and image, video
        // ['link', 'image', 'video']                         // link and image, video
      ],
      imageResize: true,
    };
    this.messagingService
      .checkFeatureValues("promotional_channel")
      .then((response) => {
        this.allowedChannels = response || [];
      });
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit(): void {
    setTimeout(() => {
      this._inputElement.nativeElement.focus();
    }, 1000);
  }
  async setSmsMaxLength() {
    let shortUrl: boolean;
    let maxLength: number;
    let regionalMaxLength: number;
    let smsMaxLength = await this.HttpService.get(
      this.BASE_URL.REVIEW_SETUP_VALUE_URL_V2(this.outlet_id)
    ).toPromise();
    let shortUrlEnabled = await this.HttpService.get(
      this.BASE_URL.CAMPAIGN_SETTINGS_V2(this.outlet_id)
    ).toPromise();
    maxLength = smsMaxLength.data["campaign_sms_template_size"];
    regionalMaxLength =
      smsMaxLength.data["regional_campaign_sms_template_size"];
    shortUrl = shortUrlEnabled.data["short_url"];
    this.smsMaxLength = maxLength;
    this.regionalSmsMaxLength = regionalMaxLength;
  }

  getDefaultTemplate() {
    return new Promise((resolve) => {
      this.HttpService.getRequest({
        customApiUrl: this.BASE_URL.MESSAGING_COMMON_SETTINGS(this.outlet_id),
      }).subscribe((response) => {
        if (response.code == 200) {
          this.default_sms_template =
            response.data.default_sms_promotional_template;
          this.default_email_template =
            response.data.default_email_promotional_template;
          resolve(true);
        }
      });
    });
  }

  get defaultTemplateId() {
    return this.emailType
      ? this.default_email_template
      : this.default_sms_template;
  }

  onContent() {
    this.setDynamicVariables(this.reviewData.review_content.value ?? "");
  }

  private getPredefinedVariable(label: string) {
    let predefinedVariable = this.predefinedVariables.find(
      (e) => e.label == label
    );
    return {
      value: predefinedVariable?.value || "",
      isEditable:
        predefinedVariable !== undefined
          ? predefinedVariable?.is_editable
          : true,
    };
  }

  placeholderText = (variable) =>
    variable?.value?.isEditable
      ? `Enter Value for ${variable?.value?.label}`
      : `${variable?.value?.label} - Cannot Edit`;

  private templateVariable(label: string) {
    let templateVariable = this.selectedTemplate?.dynamic_variables.find(
      (e) => e.variable_name == label
    );
    return templateVariable;
  }
  isTemplateVariable(label: string) {
    return this.templateVariable(label);
  }
  templateVariableArrayLength() {
    let templateVariable: any[] = this.selectedTemplate?.dynamic_variables;
    return templateVariable?.length;
  }
  getTemplateVariable(label: string) {
    let templateVariable = this.templateVariable(label);
    return {
      value: templateVariable?.variable_value || "",
      isEditable: templateVariable?.is_editable || true,
    };
  }
  private getTrimmedVariables(
    dynamicVariablesMatch: string[],
    previewContent: string = null
  ) {
    const curlyBracesTextReg = /{{(.*?)}}/;
    let newPreviewContent: string = previewContent;
    let trimmedVariables = dynamicVariablesMatch.map((variable) => {
      let newVariable = variable.match(curlyBracesTextReg)[1];
      let trimmedLabel = `{{${newVariable.trim()}}}`;
      if (newPreviewContent !== null) {
        newPreviewContent = newPreviewContent.replace(variable, trimmedLabel);
      }
      return trimmedLabel;
    });
    return { trimmedVariables, newPreviewContent };
  }
  setDynamicVariables(contentValue: string) {
    const curlyBracesReg = /{{(.*?)}}/gi;
    let dynamicVariablesMatch: string[] =
      contentValue.match(curlyBracesReg) || [];
    let { trimmedVariables } = this.getTrimmedVariables(dynamicVariablesMatch);

    if (trimmedVariables.length) {
      let dynamicVariables = trimmedVariables.reduce((variables, label) => {
        let dynamicObj = this.dynamicVariables[label];
        if (dynamicObj) {
          var [value, isEditable] = [
            dynamicObj["value"],
            dynamicObj["isEditable"],
          ];
        } else {
          var { value, isEditable } = this.getPredefinedVariable(label);
        }
        if (this.isTemplateVariable(label) !== undefined) {
          var { value } = this.getTemplateVariable(label);
        }
        return {
          ...variables,
          [label]: {
            label,
            value,
            isEditable,
          },
        };
      }, {});
      this.dynamicVariables = { ...dynamicVariables };
    } else {
      this.emptyDynamicVariable();
    }
  }
  emptyDynamicVariable() {
    this.dynamicVariables = {};
  }
  filterVariables(isPayload: boolean) {
    const curlyBracesTextReg = /{{(.*?)}}/;
    let dynamicVariables = {};
    let label: string;
    for (const key in this.dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(this.dynamicVariables, key)) {
        const variable = this.dynamicVariables[key];
        if (isPayload) {
          label = variable["label"].match(curlyBracesTextReg)[1];
        } else {
          label = variable["label"];
        }
        let value: string = variable["value"];
        if (label && value) {
          dynamicVariables[label] = value.trim();
        }
      }
    }
    return dynamicVariables;
  }
  createDynamicVariablePayload() {
    let dynamicVariables = this.filterVariables(true);
    return { dynamic_variables: dynamicVariables };
  }
  isInValidDynamicVariable() {
    let isInvalid = false;
    for (const key in this.dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(this.dynamicVariables, key)) {
        const variable = this.dynamicVariables[key];
        if (variable["value"] == "" && variable["isEditable"]) {
          isInvalid = true;
        }
      }
    }
    return isInvalid;
  }
  isVariableChanged(dynamicVariables: { [x: string]: any }) {
    let isUpdate = false;
    for (const key in dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(dynamicVariables, key)) {
        const label = key;
        const variableValue = dynamicVariables[key];
        let isTemplateVariable = this.isTemplateVariable(label) !== undefined;

        if (isTemplateVariable) {
          var value = this.getTemplateVariable(label)?.value;
          if (variableValue !== value) {
            isUpdate = true;
          }
        }
      }
    }
    return isUpdate;
  }

  getPredefinedVariables() {
    this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.GET_PREDEFINED_VARIABLES(this.outlet_id),
    }).subscribe((res) => {
      if (res.code == 200) {
        let predefinedVariables: Array<any> = res.data;
        this.predefinedVariables = predefinedVariables;
      }
    });
  }

  setDltValidation() {
    let dlt_template_id = this.reviewTemplateForm.get("dlt_template_id");
    let new_dlt_template_id = this.newDltTemplateForm.get(
      "new_dlt_template_id"
    );

    if (!this.checkInternationalCountry) {
      dlt_template_id.setValidators(Validators.required);
      new_dlt_template_id.setValidators(Validators.required);
    } else {
      dlt_template_id.clearValidators();
      new_dlt_template_id.clearValidators();
    }
    dlt_template_id.updateValueAndValidity();
    new_dlt_template_id.updateValueAndValidity();
  }

  isDoubleBytePaste(status, event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData("text");
    for (var i = 0, n = pastedText.length; i < n; i++) {
      if (pastedText.charCodeAt(i) > 255) {
        return (this.regionalLanguage = true);
      }
    }
  }
  isDoubleBytetype(status, event) {
    let content = this.reviewData.review_content.value;
    if (content) {
      for (var i = 0, n = content.length; i < n; i++) {
        if (content.charCodeAt(i) > 255) {
          this.usedCreditsRegional(content.length);

          return (this.regionalLanguage = true);
        }
      }
      this.usedCredits(content.length);

      return (this.regionalLanguage = false);
    }
  }

  choosetype($event: string) {
    this.chooseChannel = $event;
    this.sendMsg2 = false;
    if ($event == "SMS") {
      setTimeout(() => {
        this._inputElement.nativeElement.focus();
      }, 1000);
      this.smsType = false;
      this.emailType = false;
      this.emptyFields();
    } else {
      this.smsType = true;
      this.emailType = true;
      this.emptyFieldsEmail();
    }
  }

  choosetype1(e) {
    if (e === true) {
      this.brandLogo = true;
    } else {
      this.brandLogo = false;
    }
  }

  choosetype2(e) {
    if (e === true) {
      this.brandName = true;
    } else {
      this.brandName = false;
    }
  }

  choosetype3(e) {
    if (e === true) {
      this.powerBy = true;
    } else {
      this.powerBy = false;
    }
  }

  /**
   * Qr code settings function
   */
  qrCodeSettingsFunction() {
    let res: Response;
    const qr_code_setting = this.HttpService.get(
      this.BASE_URL.QRCODE_SETTINGS_URL_V2(this.outlet_id)
    );
    qr_code_setting.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        if (error.status === 404) {
          const qr_code_setting_reset = this.HttpService.put(
            this.BASE_URL.QRCODE_SETTINGS_RESET_URL_V2(this.outlet_id)
          );
          qr_code_setting_reset.subscribe(
            (data: Response) => {
              res = data;
            },
            (errors) => {
              this.toastrService.error(errors.error.message);
            },
            () => {
              if (res.code === 200 || res.code === 201) {
                this.qrCodeSettingsFunction();
              } else {
                this.toastrService.error(res.data["message"]);
              }
            }
          );
        }
      },
      () => {
        if (res.code === 200 || res.code === 201) {
          this.qrCodeSettingForm.setValue({
            brand_logo: res.data["brand_logo"],
            brand_name: res.data["brand_name"],
            description: res.data["description"],
            subtitle: res.data["subtitle"],
            title: res.data["title"],
            zceppa_powered: res.data["zceppa_powered"],
          });
          this.brandLogo = res.data["brand_logo"];
          this.brandName = res.data["brand_name"];
          this.powerBy = res.data["zceppa_powered"];
          this.qrCodeFunction();
        } else {
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }

  get newDltTemplateFormControl() {
    return this.newDltTemplateForm.controls;
  }

  /**
   * Get qr code form data
   */
  get qrCodeFormData() {
    return this.qrCodeSettingForm.controls;
  }

  /**
   * QR code genration and display
   */
  qrCodeFunction() {
    let res: Response;
    const qr_code_link = this.HttpService.get(
      this.BASE_URL.QRCODE_DISPLAY_URL_V2(this.outlet_id)
    );
    qr_code_link.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {},
      () => {
        if (res.data["url"] === null || res.data["url"] === undefined) {
          const qr_generate_service = this.HttpService.postjson(
            this.BASE_URL.QRCODE_GENERATE_URL_V2(this.outlet_id)
          );
          qr_generate_service.subscribe(
            (data: Response) => {
              res = data;
            },
            (error) => {},
            () => {
              if (res.code === 200 || res.code === 201) {
                const qr_code_links = this.HttpService.get(
                  this.BASE_URL.QRCODE_DISPLAY_URL_V2(this.outlet_id)
                );
                qr_code_links.subscribe(
                  (data: Response) => {
                    res = data;
                  },
                  (error) => {},
                  () => {
                    this.qrcode_link = res.data["url"];
                  }
                );
              }
            }
          );
        } else {
          this.qrcode_link = res.data["url"];
        }
      }
    );
  }

  /**
   * Update qr code settings
   */
  updateQrCodeSetting(Form: FormGroup) {
    let res: Response;
    this.isValidFormSubmitted = false;
    if (this.qrCodeSettingForm.invalid) {
      return;
    }
    this.isValidFormSubmitted = true;
    const data_json = {
      brand_logo: Form.controls.brand_logo.value,
      brand_name: Form.controls.brand_name.value,
      description: Form.controls.description.value,
      subtitle: Form.controls.subtitle.value,
      title: Form.controls.title.value,
      zceppa_powered: Form.controls.zceppa_powered.value,
    };
    const data_service = this.HttpService.putjson(
      this.BASE_URL.QRCODE_TEMP_UPDATE_URL_V2(this.outlet_id),
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {
        if (res.code === 200 || res.code === 201) {
          this.toastrService.success(res.data["message"]);
        } else {
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }

  /**
   * Download QR code file
   */
  downloadQrcodeFile() {
    window.open(this.qrcode_link, "_blank");
    window.setTimeout(function () {
      this.close();
    }, 1000);
  }

  /**
   * Get all data from review form
   */
  get reviewData() {
    return this.reviewTemplateForm.controls;
  }

  checkContentEdit(event) {
    if (this.selectedTemplate !== null && !this.checkInternationalCountry) {
      if (this.selectedTemplate?.content == event.target.value) {
        this.hideSaveButton = false;
      } else {
        this.hideSaveButton = true;
      }
    }
  }

  preSelectTemplate(updatedTemplate = null) {
    this.smsTemplates.forEach((_, i) => {
      if (_.id == (updatedTemplate ?? this.defaultTemplateId)) {
        this.updatedTemplate = null;
        this.isDefaultTemplate = _.default;
        this.editTemplate(_);
      }
    });
  }

  SelectTemplateAfterChanges(templateID = null) {
    let res: Response;
    this.HttpService.get(
      this.BASE_URL.MESSAGING_SETTINGS_GET_PROMOTIONAL_TEMPLATE(this.outlet_id)
    ).subscribe(
      (data: Response) => {
        res = data;
        this.all_templates = res.data["templates"];
        this.smsTemplates = this.all_templates.filter(
          (temp: any) => temp.channel == "SMS"
        );
        this.emailTemplates = this.all_templates.filter(
          (temp: any) => temp.channel == "Email"
        );

        this.default_sms_template =
          res.data["default_sms_promotional_template"];
        this.default_email_template =
          res.data["default_email_promotional_template"];
      },
      (err) => {},
      () => {
        this.preSelectTemplate(templateID);
        // this.getDefaultTemplate().then((res) => {
        //   if (res) {
        //     this.preSelectTemplate(templateID);
        //   }
        // });
      }
    );
  }

  updateCampaignTemplate(form_data: any) {
    let res: Response;
    this.HttpService.put(
      this.BASE_URL.MESSAGING_UPDATE_DELETE_PROMOTIONAL_TEMPLATE(
        this.outlet_id,
        this.reviewData.template_id.value
      ),
      form_data
    ).subscribe(
      (data: Response) => {
        res = data;
        this.updatedTemplate = this.reviewData.template_id.value;
      },
      (error) => {
        this.showError(error.error.error_message);
      },
      () => {
        this.toastrService.success(res.data["message"]);
        this.SelectTemplateAfterChanges(this.updatedTemplate);
      }
    );
  }

  createPromotionalTemplate(formData: any) {
    let res: Response;
    this.HttpService.postRequest({
      customApiUrl:
        this.BASE_URL.MESSAGING_SETTINGS_CREATE_PROMOTIONAL_TEMPLATE(
          this.outlet_id
        ),
      data: formData,
    }).subscribe(
      (data: Response) => {
        res = data;
        this.updatedTemplate = res.data["template_id"];
      },
      (error) => {
        this.showError(error.error.error_message);
      },
      () => {
        this.toastrService.success(res.data["message"]);
        this.SelectTemplateAfterChanges(this.updatedTemplate);
        this.modalService.dismissAll();
        this.emptyNewDltTemplate();
      }
    );
  }

  onSaveAsNew(Form: FormGroup) {
    this.selectedTemplate = null;
    this.addReviewTemplate(Form, true);
  }

  emptyNewDltTemplate() {
    this.newDltTemplateForm.patchValue({
      new_dlt_template_id: "",
    });
  }

  addReviewTemplate(From: FormGroup, isSaveAsNew = false) {
    this.outlet_id = this.storage.get("outlet_id");
    const x = new String(From.value["review_content"]);
    const contentVal = x.length;
    let cont: String;
    this.isValidFormSubmitted = false;
    this.setDltValidation();
    if (
      this.reviewTemplateForm.invalid ||
      (isSaveAsNew && this.newDltTemplateForm.invalid)
    ) {
      return;
    }
    if (From.controls.template_id.value === "") {
      if (x.length > this.smsMaxLength) {
        this.toastrService.warning(
          "Message content should not exceed Maximum Characters."
        );
        return;
      }
    } else {
      if (contentVal > this.smsMaxLength) {
        this.toastrService.warning(
          "Message content should not exceed Maximum Characters."
        );
        return;
      }
    }
    if (this.isInValidDynamicVariable()) {
      return;
    }
    this.isValidFormSubmitted = true;
    let res: Response;
    this.reviewTemplateForm.controls["review_content"].enable();
    this.reviewTemplateForm.controls["review_title"].enable();
    const val = From.value["review_content"].split("{{review_link}}");
    if (val.length <= 1) {
      cont = From.value["review_content"];
    } else {
      cont = val[0] + "" + "{{review_link}} ."; // From.value['review_content'];
    }
    const form_data = {
      channel: this.chooseChannel,
      title: From.value["review_title"],
      content: cont,
      is_default_template: From.controls.set_default.value,
      dlt_template_id: isSaveAsNew
        ? this.newDltTemplateForm.value["new_dlt_template_id"]
        : From.value["dlt_template_id"],
      ...this.createDynamicVariablePayload(),
    };
    this.reviewTemplateForm.controls["review_title"].disable();
    this.reviewTemplateForm.controls["review_content"].disable();
    if (this.selectedTemplate == null) {
      this.createPromotionalTemplate(form_data);
    } else {
      this.updateCampaignTemplate(form_data);
    }
  }

  onSelectTemplate(template) {
    if (this.emailType) {
      this.editTemplateEmail(template);
    } else {
      this.editTemplate(template);
    }
  }

  /**
   * Edit template
   */
  editTemplate(template) {
    this.emptyDynamicVariable();
    this.show_button1 = true;
    this.selectedTemplate = template;
    this.saveAsNewTemplateButton = true;
    this.reviewTemplateForm.controls["review_title"].disable();
    this.reviewTemplateForm.controls["review_content"].enable();
    this.selected_template_id = template.id;
    this.hideSaveButton = false;
    this.isApproved = template.is_approved;
    if (template.default === true) {
      this.show_button = true;
    } else {
      this.show_button = false;
    }
    if (this.selected_template_id === this.defaultTemplateId) {
      this.reviewTemplateForm.setValue({
        review_title: template.title,
        review_content: template.content,
        template_id: template.id,
        set_default: template.id,
        dlt_template_id: template.dlt_template_id ?? "",
      });
    } else {
      this.reviewTemplateForm.setValue({
        review_title: template.title,
        review_content: template.content,
        template_id: template.id,
        set_default: "",
        dlt_template_id: template.dlt_template_id ?? "",
      });
    }
    this.button_name = "Save";
    this.button_image = "assets/images/save-file-option.svg";
    let content = template.content;

    this.setDynamicVariables(content);
    if (content) {
      for (var j = 0, n = content.length; j < n; j++) {
        if (content.charCodeAt(j) > 255) {
          this.usedCreditsRegional(content.length);
          return (this.regionalLanguage = true);
        }
      }
      this.usedCredits(content.length);
      return (this.regionalLanguage = false);
    }
  }

  /**
   * Edit template
   */
  editTemplateEmail(template) {
    this.saveAsNewTemplateButtonEmail = true;
    this.reviewEmailTemplateForm.controls["review_title"].enable();
    this.selectedTemplate = template;
    this.saveAsNewTemplateButton = true;
    this.selected_template_id = template.id;
    this.hideSaveButton = false;
    if (this.selected_template_id === this.defaultTemplateId) {
      this.reviewEmailTemplateForm.setValue({
        review_title: template.title,
        review_content: template.content,
        template_id: template.id,
        set_default: template.id,
      });
    } else {
      this.reviewEmailTemplateForm.patchValue({
        review_title: template.title,
        review_content: template.content,
        template_id: template.id,
        set_default: "",
      });
    }
    // }
    this.editorStyles = {
      "min-height": "150px",
      height: "300px",
      ...(this.isValidFormSubmitted == false &&
        (this.reviewEmailTemplateForm.get("review_content").value == "" ||
          this.reviewEmailTemplateForm.get("review_content").value == null) && {
          border: "1px solid #ff0000",
        }),
    };
    this.reviewEmailTemplateForm.controls["review_title"].disable();
    this.button_name = "Save";
    this.button_image = "assets/images/save-file-option.svg";
  }

  /**
   *
   * @param saveAsNewTemplateModel
   * @memberof RequestTemplateComponent
   */

  saveAsNewTemplate(saveAsNewTemplateModel, ifEmail) {
    this.show_button1 = false;
    if (ifEmail) {
      this.reviewEmailTemplateForm.controls["review_title"].enable();
    } else {
      this.reviewTemplateForm.controls["review_title"].enable();
    }
    this.modalService
      .open(saveAsNewTemplateModel, {
        ariaLabelledBy: "saveAsNewTemplateModel",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.saveAsNewTemplateButton = false;
          if (ifEmail) {
            this.reviewEmailTemplateForm.controls["review_title"].disable();
          } else {
            this.reviewTemplateForm.controls["review_title"].disable();
          }
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Delete popup
   *
   * @param {*} template
   * @param {*} content
   * @param {*} index
   */
  onDeleteTemplate(templateId) {
    this.template_id = templateId;
    this.templateChannel = this.selectedTemplate?.channel;
    this.modalService
      .open(this.content, { ariaLabelledBy: "modalreviewadd" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Delete template
   */

  deletePromotionalTemplate() {
    let res: Response;
    this.HttpService.deleteRequest({
      customApiUrl: this.BASE_URL.MESSAGING_UPDATE_DELETE_PROMOTIONAL_TEMPLATE(
        this.outlet_id,
        this.template_id
      ),
    }).subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.showError(error.error.error_message);
      },
      () => {
        if (this.role === "Manager") {
          this.show_button = true;
        } else {
          this.show_button = false;
        }
        this.button_name = "Add";
        this.button_image = "assets/images/add-fff.svg";
        this.modalService.dismissAll("content");
        this.showSuccess("Template deleted successfully");
        if (this.templateChannel == "SMS") {
          this.reviewTemplateForm.patchValue({
            review_title: "",
            review_content: "",
            template_id: "",
            set_default: "",
            dlt_template_id: "",
          });
          this.selected_template_id = undefined;
          this.emptyFields();
        } else {
          this.emptyFieldsEmail();
        }
        this.getPromotionalTemplates();
      }
    );
  }

  usedCredits(smslen) {
    this.used_credits = Math.ceil(Number(smslen) / 160);
  }
  usedCreditsRegional(smslen) {
    this.regional_used_credits = Math.ceil(Number(smslen) / 70);
  }
  getPromotionalTemplates() {
    let res: Response;

    this.outlet_id = this.storage.get("outlet_id");
    const dataService = this.HttpService.get(
      this.BASE_URL.MESSAGING_SETTINGS_GET_PROMOTIONAL_TEMPLATE(this.outlet_id)
    );
    dataService.subscribe((data: Response) => {
      res = data;
      console.log("MESSAGING_SETTINGS_GET_PROMOTIONAL_TEMPLATE", data.data);
      this.all_templates = res.data["templates"];
      this.smsTemplates = this.all_templates.filter(
        (temp) => temp.channel == "SMS"
      );
      this.emailTemplates = this.all_templates.filter(
        (temp) => temp.channel == "Email"
      );
      this.showDltWarning = this.smsTemplates.every(
        (_) => _.is_approved == null || _.is_approved == false
      );

      this.available_channels = data.data.available_channels;
      if (this.available_channels.length > 0) {
        // disable email from transactional template
        let emailIndex = this.available_channels.findIndex(
          (channel: any) => channel?.value == "Email"
        );
        if (emailIndex > -1) {
          this.available_channels[emailIndex].isDisabled = true;
        }
        this.chooseChannel = this.available_channels[0]?.value;
      }

      this.default_sms_template = res.data["default_sms_promotional_template"];
      this.default_email_template =
        res.data["default_email_promotional_template"];
      this.permissions = res.data["permissions"];
      this.is_campaign_blocked = res.data["is_product_blocked"];
      this.campaign_warning_text = res.data["product_warning_text"];
      this.loading = false;
    });
  }

  createEmailTemplate() {
    this.isValidFormSubmitted = false;

    this.editorStyles = {
      "min-height": "150px",
      height: "300px",
      ...(this.isValidFormSubmitted == false &&
        (this.reviewEmailTemplateForm.get("review_content").value == "" ||
          this.reviewEmailTemplateForm.get("review_content").value == null) && {
          border: "1px solid #ff0000",
        }),
    };

    if (this.reviewEmailTemplateForm.invalid) {
      return;
    }
    this.isValidFormSubmitted = true;
    const form_data = {
      title: this.reviewEmailTemplateForm.getRawValue().review_title,
      content: this.reviewEmailTemplateForm.value.review_content,
    };

    this.HttpService.postRequest({
      customApiUrl: this.BASE_URL.CAMPAIGN_EMAIL_CREATE(this.outlet_id),
      data: form_data,
    }).subscribe(
      (res: any) => {
        if (res.code == 200) {
          this.toastrService.success(res.data.message);
        }
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {
        const dataService = this.HttpService.get(
          this.BASE_URL.LIST_CAMPAIGN_V2_WP(this.outlet_id)
        );
        dataService.subscribe(
          (res: any) => {
            this.all_templates = res.data.templates;
            this.smsTemplates = this.all_templates.filter(
              (temp) => temp.channel == "sms"
            );
            this.emailTemplates = this.all_templates.filter(
              (temp) => temp.channel !== "sms"
            );
          },
          (err) => {},
          () => {
            this.emailTemplates.forEach((template, index) => {
              if (
                template.title ==
                this.reviewEmailTemplateForm.getRawValue().review_title
              ) {
                this.editTemplateEmail(template);
              }
            });
          }
        );
        this.modalService.dismissAll();
      }
    );
  }
  updateEmailTemplateDefault() {
    return new Promise((resolve) => {
      this.HttpService.putRequest({
        customApiUrl: this.BASE_URL.CAMPAIGN_EMAIL_TEMPLATE_UPDATE(
          this.outlet_id,
          this.reviewEmailTemplateForm.value.template_id
        ),
      }).subscribe((response) => {
        if (response.code == 200) {
          this.toastrService.success(response.data.message);
        }
        resolve(true);
      });
    });
  }

  afterEmailUpdate() {
    this.getDefaultTemplate().then((res) => {
      if (res) {
        const dataService = this.HttpService.get(
          this.BASE_URL.LIST_CAMPAIGN_V2_WP(this.outlet_id)
        );
        dataService.subscribe(
          (res: any) => {
            this.all_templates = res.data.templates;
            this.smsTemplates = this.all_templates.filter(
              (temp: any) => temp.channel == "SMS"
            );
            this.emailTemplates = this.all_templates.filter(
              (temp: any) => temp.channel == "Email"
            );
          },
          (err) => {},
          () => {
            this.emailTemplates.forEach((template, index) => {
              if (
                template.id == this.reviewEmailTemplateForm.value.template_id
              ) {
                this.editTemplateEmail(template);
              }
            });
          }
        );
      }
    });
  }
  updateEmailTemplate() {
    this.isValidFormSubmitted = false;

    this.editorStyles = {
      "min-height": "150px",
      height: "300px",
      ...(this.isValidFormSubmitted == false &&
        (this.reviewEmailTemplateForm.get("review_content").value == "" ||
          this.reviewEmailTemplateForm.get("review_content").value == null) && {
          border: "1px solid #ff0000",
        }),
    };

    if (this.reviewEmailTemplateForm.invalid) {
      return;
    }
    this.isValidFormSubmitted = true;
    const form_data = {
      title: this.reviewEmailTemplateForm.getRawValue().review_title,
      content: this.reviewEmailTemplateForm.value.review_content,
    };

    this.HttpService.putRequest({
      customApiUrl: this.BASE_URL.CAMPAIGN_EMAIL_UPDATE(
        this.outlet_id,
        this.reviewEmailTemplateForm.value.template_id
      ),
      data: form_data,
    }).subscribe(
      (res: any) => {
        if (res.code == 200) {
          this.toastrService.success(res.data.message);
          if (this.reviewEmailTemplateForm.value.set_default) {
            this.updateEmailTemplateDefault().then((res) => {
              if (res) {
                this.afterEmailUpdate();
              }
            });
          } else {
            this.afterEmailUpdate();
          }
        }
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {}
    );
  }
  quillOutput() {
    this.editorStyles = {
      "min-height": "150px",
      height: "300px",
      ...(this.isValidFormSubmitted == false &&
        (this.reviewEmailTemplateForm.get("review_content").value == "" ||
          this.reviewEmailTemplateForm.get("review_content").value == null) && {
          border: "1px solid #ff0000",
        }),
    };
  }
  /**
   *common data service function for listing template
   */
  commonDataService() {
    this.outlet_id = this.storage.get("outlet_id");
  }

  /**
   * Get all data from review Email form
   */
  get reviewEmailData() {
    return this.reviewEmailTemplateForm.controls;
  }

  /**
   * Close popup model
   */
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  /**
   * Remove validation
   */
  removeValidation(e) {
    this.isValidFormSubmitted = true;
  }

  /**
   * Check box model
   */
  FieldsChange(values: any, i) {
    // this.showSuccess('Template successfully added');
  }

  /**
   * Empty fields
   */
  emptyFields() {
    this.show_button1 = false;
    this.isValidFormSubmitted = true;
    this.saveAsNewTemplateButton = false;
    this.reviewTemplateForm.controls["review_title"].enable();
    this.selected_template_id = undefined;
    this.selectedTemplate = null;
    this.button_name = "Add";
    this.button_image = "assets/images/add-fff.svg";
    this.hideSaveButton = false;
    this.emptyDynamicVariable();
    this.reviewTemplateForm.setValue({
      review_title: "",
      review_content: "",
      template_id: "",
      set_default: "",
      dlt_template_id: "",
    });
    if (this.role === "Manager") {
      this.show_button = true;
    } else {
      this.show_button = false;
    }
  }

  /**
   * Empty fields
   */
  emptyFieldsEmail() {
    console.log("empty email field");

    this.saveAsNewTemplateButtonEmail = false;
    this.isValidFormSubmitted = true;
    this.reviewEmailTemplateForm.controls["review_title"].enable();
    this.selected_template_id = undefined;
    this.selectedTemplate = null;
    this.button_name = "Add";
    this.button_image = "assets/images/add-fff.svg";
    this.editorStyles = {
      "min-height": "150px",
      height: "300px",
    };
    this.reviewEmailTemplateForm.setValue({
      review_title: "",
      review_content: "",
      template_id: "",
      set_default: "",
    });
    if (this.role === "Manager") {
      this.show_button = true;
    } else {
      this.show_button = false;
    }
  }

  /**
   *Common toastr for success function
   */
  showSuccess(msg: string) {
    this.toastrService.success(msg);
  }

  /**
   * Common toastr for error function
   */
  showError(msg: string) {
    this.toastrService.error(msg);
  }

  saveTemplate() {
    this.selected_template_id = undefined;
    this.show_button1 = false;
  }

  style = {
    div: {
      "text-align": "center",
      margin: "5% 25%",
    },
    ".qrshowhide": {
      border: "8px solid #03c0c2",
    },
    ".printsec": {
      "margin-top": "15px",
      "text-align": "center",
      color: "#4a4a4a",
    },
    ".logourl": {
      width: "60px",
    },
    ".phimgsec": {
      display: "none",
    },
    h4: {
      color: "#03c0c2",
      "font-weight": "600",
      "font-size": "1.21875rem",
    },

    ".scanreview": {
      color: "blueviolet",
      "font-size": "14px",
      "font-weight": "600",
      "text-align": "center",
    },
    ".scanreviewp": {
      "font-size": "10px",
      "padding-top": "15px",
      "text-align": "center",
      width: "50%",
    },
    ".powerdbylogo": {
      width: "100px",
    },
    ".qrimage": {
      width: "150px",
    },
  };
}
